import { EyeScanIcon } from "@cynthai/icons";
import type { ComponentType, SVGProps } from "react";
import { Button, Dialog, DialogTrigger, Popover } from "react-aria-components";

export type CountListChipItem = { id: string; name: string };

export type CountListChipProps = {
  items: readonly CountListChipItem[];
  /** names both the chip and the popover it opens */
  label: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
};

export function CountListChip({
  items,
  label,
  icon: Icon,
}: Readonly<CountListChipProps>) {
  return (
    <DialogTrigger>
      <Button
        aria-label={label}
        className="border-tertiary/50 aria-expanded:border-primary/50 aria-expanded:bg-primary/10 aria-expanded:text-primary flex cursor-pointer items-center gap-2 rounded-md border py-[3px] pr-2 pl-1 text-xs whitespace-nowrap outline-none"
      >
        <EyeScanIcon aria-hidden width={16} height={16} />
        {items.length}
      </Button>
      <Popover
        placement="bottom"
        className="border-border-table-header/50 bg-secondary rounded-md border px-0.5 py-2"
      >
        <Dialog aria-label={label} className="flex flex-col gap-1 outline-none">
          {items.map((item) => (
            <div
              key={item.id}
              className="text-text-primary flex items-center gap-2 px-3 py-1 text-sm"
            >
              <Icon aria-hidden width={16} height={16} />
              {item.name}
            </div>
          ))}
        </Dialog>
      </Popover>
    </DialogTrigger>
  );
}
